module.exports = __webpack_public_path__ + "static/mynestegg-logo@3x-0b86234153e899f4a39927b45a141868.png";